import { AxiosResponse } from 'axios';
import { history } from '../../history';
import { getAxiosPublicInstance, getAxiosSecureInstance } from '../../utilities/AxiosClient';
import { removeKreezeeSession, removeOrganizationId } from '../../utilities/LocalStorage';

export function loginWithEmail(
  username: string,
  password: string,
  invitationId?: string | undefined,
): Promise<AxiosResponse> {
  return getAxiosPublicInstance().post('/api/login', null, {
    params: {
      email: username,
      password: password,
      invitationId: invitationId,
    },
  });
}

export function loginWithFacebook(accesstoken: string, culture: string): Promise<AxiosResponse> {
  return getAxiosPublicInstance().post(`/api/login/facebook`, null, {
    params: {
      idToken: accesstoken,
      culture: culture,
    },
  });
}

export function loginWithGoogle(accesstoken: string, culture: string): Promise<AxiosResponse> {
  return getAxiosPublicInstance().post(`/api/login/google`, null, {
    params: {
      idToken: accesstoken,
      culture: culture,
    },
  });
}

export function loginWithToken(): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post('/api/login/token');
}

export async function logout(): Promise<void> {
  try {
    removeKreezeeSession();
    removeOrganizationId();
    history.push('/login');
  } catch (e) {
    console.log(e);
  }
}
